export default "__VITE_ASSET__127c7960__"